import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchInitiativesForTopicFailure, fetchInitiativesForTopicSuccess } from "entities/initiatives/actions";
import type { FetchInitiativeDefaultAction } from "entities/initiatives/actionTypes";
import type { Initiative } from "entities/initiatives/types";

export function* fetchInitiativesForTopicSaga(action: FetchInitiativeDefaultAction) {
  const { id, offset, limit, search, ...filters } = action.payload;
  try {
    const payload: Initiative[] = yield apiFetch(`topic/${id}/project`, {
      queryParams: {
        offset,
        limit,
        name: search,
        owner: filters.type,
      },
    });

    yield put(
      fetchInitiativesForTopicSuccess(
        {
          topicId: id,
          data: payload,
        },
        action.payload,
      ),
    );
  } catch {
    yield put(fetchInitiativesForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
